import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    "X-API-USERNAME": process.env.REACT_APP_API_USERNAME,
    "X-API-PASSWORD": process.env.REACT_APP_API_PASSWORD,
  },
});


api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
      config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
      if (error.response && error.response.status === 401) {
          // Force logout if token is stolen, expired, or manipulated
          localStorage.removeItem('admin_token');
          localStorage.removeItem('admin_user');
          window.location.href = '/admin';
      }
      return Promise.reject(error);
  }
);

export default api;